import { render, staticRenderFns } from "./ImsProperties.vue?vue&type=template&id=0b856262&scoped=true"
import script from "./ImsProperties.vue?vue&type=script&lang=js"
export * from "./ImsProperties.vue?vue&type=script&lang=js"
import style0 from "./ImsProperties.vue?vue&type=style&index=0&id=0b856262&prod&scoped=true&lang=css"
import style1 from "./ImsProperties.vue?vue&type=style&index=1&id=0b856262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b856262",
  null
  
)

export default component.exports